module.exports = __webpack_public_path__ + "images/marketing_site/blog_headshot/john_serrantino.jpg";